import { WorkCenterUtilizationReport } from './workcenter-utilization/work-center-utilization-report'
import { Property } from '../properties/property'

export const mapInvolvedProcessPlanIds: (reports: WorkCenterUtilizationReport[]) => string[] = (
  reports: WorkCenterUtilizationReport[]
) => [
  ...new Set(reports.flatMap((r) => r.processPlanIds)), // unique results
]

export const roundQuantity: (quantity: number, property?: Property) => number = (
  quantity: number,
  property?: Property
) => Math.round(quantity) // TODO: replace with rounding according to it-quantity rounding mode
